module.exports = "https://web-assets.ifttt.com/packs/media/icons/exclamation-00938911.png";